(function (global) {
  "use strict";

  var USE_LOCAL_CONFIG_ONLY = false;
  var DETAIL_API_PATH = "/api/klaiyi/crown_pass/detail";
  var CART_API_PATH = "/api/klaiyi/crown_pass/cart";
  var AUTH_TOKEN = "Bearer 6JXquydq6hZG4aJyN8A5";
  var MOCK_STATUS_KEY = "klaiyi_crown_pass_mock_status";
  var PDP_CART_SELECTED_KEY = "klaiyi_crown_pass_pdp_selected";
  var RETENTION_POPUP_SHOWN_KEY = "klaiyi_crown_pass_retention_shown";
  var DEFAULT_SELECTED_DISMISSED_KEY =
    "klaiyi_crown_pass_default_selected_dismissed";

  var configCacheByKey = {};
  var configPromiseByKey = {};

  /**
   * 未登录 + /crown_pass/cart：接口 enabled=false 时在主题购物车仍按「已开启」展示。
   * 后台暂不能全局 enabled=true（会影响结算扩展）。正式上线改为 false，走 api_enabled / 接口 enabled。
   */
  var CROWN_PASS_GUEST_CART_IGNORE_ENABLED_FALSE = true;

  function isApiEnabledExplicitlyOff(enabled) {
    if (enabled === false || enabled === 0) {
      return true;
    }
    if (typeof enabled === "string" && enabled.trim().toLowerCase() === "false") {
      return true;
    }
    return false;
  }

  /** 付费会员总开关（detail/cart 的 status）；未返回时视为开启，兼容旧接口 */
  function isCrownPassMasterSwitchOn(data) {
    if (!data || data.status == null) {
      return true;
    }
    return !isApiEnabledExplicitlyOff(data.status);
  }

  function isCartGuestContext(ctx) {
    return !(ctx && ctx.customerId);
  }

  function resolveCartApiEnabled(data, ctx) {
    var apiEnabled = !isApiEnabledExplicitlyOff(data && data.enabled);
    if (
      CROWN_PASS_GUEST_CART_IGNORE_ENABLED_FALSE &&
      isCartGuestContext(ctx) &&
      isApiEnabledExplicitlyOff(data && data.enabled)
    ) {
      return true;
    }
    return apiEnabled;
  }

  function getApiBase() {
    return global.API_BASE || "https://plugin.kriyya.com";
  }

  function buildLocalConfig(ctx) {
    var userStatus = "guest";
    if (ctx && ctx.customerId) {
      userStatus = "non_member";
    }

    return {
      enabled: true,
      feature_status: true,
      excluded_product_ids: [],
      excluded_collection_ids: [],
      membership_name: "Crown Pass",
      membership_variant_id: (ctx && ctx.membershipVariantId) || null,
      membership_price_text: "$19.9",
      membership_price_cents: 1990,
      rates: {
        with_code: 0.07,
        first_order: 0.07,
        repeat_order: 0.05,
      },
      user_status: userStatus,
      copy: {
        guest: {
          title: "Save Extra {amount} With {membership_name}",
          button_text: "Get It",
        },
        non_member: {
          title: "Save Extra {amount} With {membership_name}",
          button_text: "Get It",
        },
        member: {
          title: "Save Extra {amount} With {membership_name}",
          button_text: "Check Now",
        },
      },
      cart: {
        upsell_title: "{price} Klaiyi Crown Pass",
        active_title: "Your Crown Pass Is Active",
        upsell_banner_title: "Save Extra {amount} Today!",
        upsell_banner_subtitle:
          "Extra 7% OFF Your First Order, 5% OFF All Later Orders",
        upsell_banner_footer: "Valid in 90 Days | Unlimited Use",
        member_banner_title: "90-Day Membership",
        member_banner_subtitle: "Extra 5% OFF This Order",
        member_banner_footer: "Valid: Sep 1, 2026 - Dec 1, 2026",
      },
      membership_valid_from: "2026-09-01",
      membership_valid_to: "2026-12-01",
      cart_popup: {
        ribbon_text: "KLAIYI Crown Pass Benefits",
        title: "Save Extra {amount} Today!",
        non_member_footer: "90-Day Membership",
        benefits: [
          "Extra 7% Off For Your First Order.",
          "Extra 5% Off All Later Orders.",
          "Could Be Used With Other Discounts.",
        ],
      },
      popup: {
        ribbon_text: "KLAIYI Crown Pass Benefits",
        title: "Save Extra {amount} Today!",
        purchase_button_text: "$19.90 / 90 DAYS - GET IT",
        active_button_text: "CROWN PASS ACTIVE - USE NOW",
        cancel_text: "Cancel",
        validity_text: "VALID: SEP.1.2026 - DEC.1.2026",
        benefits: [
          "Extra 7% Off For Your First Order.",
          "Extra 5% Off All Later Orders.",
          "Could Be Used With Other Discounts.",
        ],
      },
    };
  }

  function getMockMembershipStatus() {
    try {
      return global.sessionStorage.getItem(MOCK_STATUS_KEY) || "none";
    } catch (err) {
      return "none";
    }
  }

  function setMockMembershipStatus(status) {
    try {
      if (!status || status === "none") {
        global.sessionStorage.removeItem(MOCK_STATUS_KEY);
      } else {
        global.sessionStorage.setItem(MOCK_STATUS_KEY, status);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function getPdpCartSelected() {
    try {
      return (
        global.sessionStorage.getItem(PDP_CART_SELECTED_KEY) === "true" ||
        global.localStorage.getItem(PDP_CART_SELECTED_KEY) === "true"
      );
    } catch (err) {
      return false;
    }
  }

  function setPdpCartSelected(selected) {
    try {
      if (selected) {
        global.sessionStorage.setItem(PDP_CART_SELECTED_KEY, "true");
        global.localStorage.setItem(PDP_CART_SELECTED_KEY, "true");
      } else {
        global.sessionStorage.removeItem(PDP_CART_SELECTED_KEY);
        global.localStorage.removeItem(PDP_CART_SELECTED_KEY);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function isDefaultSelectedConfig(config) {
    return !!(
      config &&
      config.default_selected === true &&
      !getDefaultSelectedDismissed() &&
      !isPurchasedMember(config)
    );
  }

  function shouldAutoSelectCrownPassFromPdp(config) {
    if (getDefaultSelectedDismissed()) {
      return false;
    }
    if (getPdpCartSelected() || getMockMembershipStatus() === "active") {
      return true;
    }
    if (isDefaultSelectedConfig(config)) {
      return true;
    }
    return isPdpPassSelected(config);
  }

  function applyDefaultSelectedFromConfig(config, ctx) {
    if (!isDefaultSelectedConfig(config)) {
      return Promise.resolve();
    }
    setPdpCartSelected(true);
    return persistPdpSelectionToShopifyCart().catch(function (err) {
      console.warn("[CrownPass] default_selected persist failed:", err);
    });
  }

  function getRetentionPopupShown() {
    try {
      if (global.localStorage.getItem(RETENTION_POPUP_SHOWN_KEY) === "true") {
        return true;
      }
      return global.sessionStorage.getItem(RETENTION_POPUP_SHOWN_KEY) === "true";
    } catch (err) {
      return false;
    }
  }

  function setRetentionPopupShown() {
    try {
      global.localStorage.setItem(RETENTION_POPUP_SHOWN_KEY, "true");
      global.sessionStorage.setItem(RETENTION_POPUP_SHOWN_KEY, "true");
    } catch (err) {
      /* ignore */
    }
  }

  function getRetentionRatePercents(config) {
    var first =
      config && config.first_rate != null ? Number(config.first_rate) : NaN;
    var renew =
      config && config.renew_rate != null ? Number(config.renew_rate) : NaN;
    var rates = (config && config.rates) || {};

    if (isNaN(first)) {
      first = Math.round(Number(rates.first_order || 0.07) * 100);
    }
    if (isNaN(renew)) {
      renew = Math.round(Number(rates.repeat_order || 0.05) * 100);
    }

    return {
      first: first || 7,
      renew: renew || 5,
    };
  }

  function updateShopifyCartSelectionAttribute(selected) {
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          crown_pass_selected: selected ? "true" : "false",
        },
      }),
    }).then(function (res) {
      if (!res.ok) {
        throw new Error("cart/update.js HTTP " + res.status);
      }
      return res.json();
    });
  }

  function persistPdpSelectionToShopifyCart() {
    return updateShopifyCartSelectionAttribute(true);
  }

  function clearPdpSelectionFromShopifyCart() {
    return updateShopifyCartSelectionAttribute(false);
  }

  function changeShopifyCartLineQuantity(lineKey, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
      }),
    }).then(function (res) {
      if (!res.ok) {
        throw new Error("cart/change.js HTTP " + res.status);
      }
      return res.json();
    });
  }

  function removeAllMembershipLinesFromShopifyCart(cart, config) {
    function step(currentCart) {
      if (!currentCart || !currentCart.items || !currentCart.items.length) {
        return Promise.resolve(currentCart);
      }
      var line = null;
      var i;
      for (i = 0; i < currentCart.items.length; i++) {
        if (isMembershipLine(currentCart.items[i], config)) {
          line = currentCart.items[i];
          break;
        }
      }
      if (!line) {
        return Promise.resolve(currentCart);
      }
      return changeShopifyCartLineQuantity(line.key, 0).then(function () {
        return fetchShopifyCartJson().then(step);
      });
    }
    return step(cart);
  }

  /** 用户取消勾选：移除会籍 SKU 并写入 crown_pass_selected=false（结账扩展读此状态） */
  function deselectCrownPassOnShopifyCart(config) {
    return fetchShopifyCartJson()
      .then(function (cart) {
        return removeAllMembershipLinesFromShopifyCart(cart, config);
      })
      .then(function () {
        return clearPdpSelectionFromShopifyCart();
      })
      .catch(function (err) {
        console.warn("[CrownPass] deselect on cart failed:", err);
        return clearPdpSelectionFromShopifyCart();
      });
  }

  function fetchShopifyCartJson() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) {
        throw new Error("cart.js HTTP " + res.status);
      }
      return res.json();
    });
  }

  function crownPassSleep(ms) {
    return new Promise(function (resolve) {
      global.setTimeout(resolve, ms);
    });
  }

  function getPdpContext(productId) {
    var ctxMap = global.__CROWN_PASS_PDP__ || {};
    return (
      ctxMap[productId] ||
      ctxMap[String(productId)] ||
      (productId ? { productId: productId } : null)
    );
  }

  function buildMembershipCartAddItem(config) {
    if (!config) return null;
    var variantId = config.membership_variant_id;
    if (variantId == null || variantId === "") return null;
    var parsedId = parseInt(String(variantId), 10);
    return {
      id: !isNaN(parsedId) && parsedId > 0 ? parsedId : variantId,
      quantity: 1,
      properties: {
        _crown_pass_membership: "true",
      },
    };
  }

  function payloadToMainCartItem(payload) {
    if (!payload) return null;
    var item = {
      id: payload.id,
      quantity: payload.quantity != null ? payload.quantity : 1,
    };
    if (payload.properties) {
      item.properties = payload.properties;
    }
    return item;
  }

  function preparePdpCartAddPayloadWithMembership(basePayload, productId) {
    var ctx = getPdpContext(productId);
    if (!ctx || !basePayload || !basePayload.id) {
      return Promise.resolve(basePayload);
    }
    return loadConfig(ctx)
      .then(function (config) {
        if (!isCrownPassFeatureEnabled(config, ctx)) {
          return basePayload;
        }
        return fetchShopifyCartJson().then(function (cart) {
          var autoSelect = shouldAutoSelectCrownPassFromPdp(config);
          var hasMembershipLine = cartHasMembershipLine(cart, config);
          var attrSelected =
            cart.attributes &&
            cart.attributes.crown_pass_selected === "true";

          if (!autoSelect) {
            setPdpCartSelected(false);
            if (hasMembershipLine || attrSelected) {
              return deselectCrownPassOnShopifyCart(config).then(function () {
                return basePayload;
              });
            }
            return basePayload;
          }

          setPdpCartSelected(true);
          var mainItem = payloadToMainCartItem(basePayload);
          if (!mainItem) {
            return basePayload;
          }

          if (hasMembershipLine) {
            return persistPdpSelectionToShopifyCart()
              .catch(function (err) {
                console.warn("[CrownPass] persist before PDP add:", err);
              })
              .then(function () {
                return mainItem;
              });
          }

          var memItem = buildMembershipCartAddItem(config);
          if (!memItem) {
            return persistPdpSelectionToShopifyCart()
              .catch(function (err) {
                console.warn("[CrownPass] persist before PDP add:", err);
              })
              .then(function () {
                return mainItem;
              });
          }

          return persistPdpSelectionToShopifyCart()
            .catch(function (err) {
              console.warn("[CrownPass] persist before batched add:", err);
            })
            .then(function () {
              return { items: [mainItem, memItem] };
            });
        });
      })
      .catch(function (err) {
        console.warn("[CrownPass] prepare batched PDP add failed:", err);
        return basePayload;
      });
  }

  function waitForMembershipLineInCart(config, maxWaitMs) {
    var deadline = Date.now() + (maxWaitMs != null ? maxWaitMs : 3500);
    function poll() {
      return fetchShopifyCartJson().then(function (cart) {
        if (cartHasMembershipLine(cart, config)) {
          return true;
        }
        if (Date.now() >= deadline) {
          return false;
        }
        return crownPassSleep(180).then(poll);
      });
    }
    return poll();
  }

  function postMembershipAddRequest(variantId) {
    var parsedId = parseInt(String(variantId), 10);
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: !isNaN(parsedId) && parsedId > 0 ? parsedId : variantId,
        quantity: 1,
        properties: {
          _crown_pass_membership: "true",
        },
      }),
    }).then(function (res) {
      return res.text().then(function (text) {
        if (!res.ok) {
          var msg = "cart/add.js membership HTTP " + res.status;
          if (text) {
            try {
              var data = JSON.parse(text);
              if (data && (data.description || data.message)) {
                msg = data.description || data.message;
              }
            } catch (parseErr) {
              /* ignore */
            }
          }
          throw new Error(msg);
        }
        return updateShopifyCartSelectionAttribute(true);
      });
    });
  }

  function addMembershipVariantToCart(config, options) {
    options = options || {};
    if (!config) {
      return Promise.resolve();
    }
    var variantId = config.membership_variant_id;
    if (variantId == null || variantId === "") {
      return updateShopifyCartSelectionAttribute(true);
    }

    return fetchShopifyCartJson()
      .then(function (cart) {
        if (cartHasMembershipLine(cart, config)) {
          return updateShopifyCartSelectionAttribute(true);
        }
        return postMembershipAddRequest(variantId);
      })
      .catch(function (err) {
        console.warn("[CrownPass] membership variant add failed:", err);
        if (options.strict) {
          throw err;
        }
        return updateShopifyCartSelectionAttribute(true);
      });
  }

  function ensureCrownPassMembershipAfterPdpAdd(productId, options) {
    options = options || {};
    var ctx = getPdpContext(productId);
    if (!ctx) {
      return Promise.resolve(false);
    }

    return loadConfig(ctx)
      .then(function (config) {
        if (!isCrownPassFeatureEnabled(config, ctx)) {
          return false;
        }
        if (!shouldAutoSelectCrownPassFromPdp(config)) {
          return deselectCrownPassOnShopifyCart(config).then(function () {
            return false;
          });
        }
        setPdpCartSelected(true);
        return fetchShopifyCartJson()
          .then(function (cart) {
            if (cartHasMembershipLine(cart, config)) {
              return Promise.resolve(true);
            }
            return addMembershipVariantToCart(config).then(function () {
              return false;
            });
          })
          .then(function (alreadyInCart) {
            if (alreadyInCart) {
              return updateShopifyCartSelectionAttribute(true).then(function () {
                return true;
              });
            }
            if (!options.awaitMembershipLine) {
              return updateShopifyCartSelectionAttribute(true).then(function () {
                return true;
              });
            }
            return waitForMembershipLineInCart(
              config,
              options.maxWaitMs != null ? options.maxWaitMs : 3500
            );
          })
          .then(function (hasLine) {
            if (hasLine === true) {
              return updateShopifyCartSelectionAttribute(true).then(function () {
                return true;
              });
            }
            if (!hasLine) {
              console.warn(
                "[CrownPass] membership line still missing after PDP add; retry once"
              );
            }
            return addMembershipVariantToCart(config)
              .then(function () {
                return waitForMembershipLineInCart(config, 2000);
              })
              .then(function (ok) {
                if (!ok) {
                  console.warn(
                    "[CrownPass] membership line missing — checkout may omit pass SKU"
                  );
                }
                return updateShopifyCartSelectionAttribute(true).then(function () {
                  return ok;
                });
              });
          });
      })
      .catch(function (err) {
        console.warn("[CrownPass] ensure membership after PDP add:", err);
        return false;
      });
  }

  function legacyCustomerId(customerId) {
    if (customerId == null || customerId === "") return "";
    return String(customerId).split("/").pop();
  }

  function getConfigCacheKey(ctx) {
    if (ctx && ctx.productId) {
      return "pdp:" + ctx.productId;
    }
    var customerKey =
      ctx && ctx.customerId ? String(ctx.customerId) : "guest";
    return "cart:" + customerKey;
  }

  function parseApiPayload(payload) {
    if (!payload) return null;
    if (payload.data) {
      if (payload.code != null && payload.code !== 200000) {
        return null;
      }
      return payload.data;
    }
    if (payload.enabled != null || payload.pass_variant_id != null) {
      return payload;
    }
    return null;
  }

  function normalizeTemplatePlaceholders(text) {
    return String(text || "").replace(/\{save\}/g, "{amount}");
  }

  function mapWidgetToPdpCopy(widget, localCopy) {
    var w = widget || {};
    var titleTemplate = normalizeTemplatePlaceholders(w.main || w.banner_title);
    if (
      !titleTemplate &&
      w.title &&
      /(\{amount\}|\{save\}|save extra)/i.test(String(w.title))
    ) {
      titleTemplate = normalizeTemplatePlaceholders(w.title);
    }
    var buttonText = w.button_text || w.action_text || null;

    function mergeStatus(status, fallbackButton) {
      var base = localCopy[status] || localCopy.guest || {};
      var apiCopy =
        (w.copy && w.copy[status]) ||
        (widget && widget[status]) ||
        null;
      var merged = {
        title: base.title,
        button_text: base.button_text,
        button_url: base.button_url,
      };
      if (apiCopy && typeof apiCopy === "object") {
        merged = Object.assign(merged, apiCopy);
      }
      if (titleTemplate) {
        merged.title = titleTemplate;
      }
      if (buttonText) {
        merged.button_text = buttonText;
      } else if (fallbackButton) {
        merged.button_text = fallbackButton;
      }
      return merged;
    }

    return {
      guest: mergeStatus("guest", "Get It"),
      non_member: mergeStatus("non_member", "Get It"),
      member: mergeStatus("member", "Check Now"),
    };
  }

  function mapWidgetToPdpPopup(widget, data, localPopup) {
    var w = widget || {};
    var durationDays =
      data && data.duration_days != null ? data.duration_days : 90;
    var popup = Object.assign({}, localPopup, data.popup || {});

    if (w.main) {
      popup.title = normalizeTemplatePlaceholders(w.main);
    }
    if (w.title) {
      popup.purchase_button_text = String(w.title).toUpperCase().indexOf("GET") >= 0
        ? w.title
        : w.title + " - GET IT";
    }
    if (w.note) {
      popup.purchase_note = w.note;
    }
    if (w.sub) {
      popup.benefits = popup.benefits || localPopup.benefits;
      if (popup.benefits && popup.benefits.length > 1) {
        popup.benefits = popup.benefits.slice();
        popup.benefits[0] = normalizeTemplatePlaceholders(w.sub);
      }
    }
    if (data && data.duration_days != null && popup.purchase_button_text) {
      popup.purchase_button_text = popup.purchase_button_text.replace(
        /\d+\s*DAYS/i,
        durationDays + " DAYS"
      );
    }
    return popup;
  }

  function normalizeDetailApiData(data, ctx) {
    var local = buildLocalConfig(ctx || {});
    var firstRate = data.first_rate != null ? Number(data.first_rate) : 7;
    var renewRate = data.renew_rate != null ? Number(data.renew_rate) : 5;
    var withCodeRate = data.rate != null ? Number(data.rate) : firstRate;
    var copy = data.copy
      ? Object.assign({}, local.copy, data.copy)
      : mapWidgetToPdpCopy(data.widget, local.copy);

    var masterOn = isCrownPassMasterSwitchOn(data);

    return {
      enabled: data.enabled !== false,
      feature_status: masterOn,
      api_status: masterOn,
      is_excluded: data.is_excluded === true,
      discountable: data.discountable !== false,
      _pdpDetailApi: true,
      rate: withCodeRate,
      first_rate: firstRate,
      renew_rate: renewRate,
      is_member: Boolean(data.is_member),
      user_status: data.is_member
        ? "member"
        : ctx && ctx.customerId
          ? "non_member"
          : "guest",
      default_selected: data.default_selected === true,
      membership_name: data.membership_name || local.membership_name,
      membership_variant_id:
        data.pass_variant_id || local.membership_variant_id || null,
      membership_price_text:
        data.membership_price_text || local.membership_price_text,
      membership_price_cents:
        data.membership_price_cents != null
          ? data.membership_price_cents
          : local.membership_price_cents,
      membership_valid_from: data.valid_from || data.membership_valid_from,
      membership_valid_to: data.valid_to || data.membership_valid_to,
      duration_days: data.duration_days != null ? data.duration_days : 90,
      excluded_product_ids: (data.excluded_product_ids || []).map(function (id) {
        return String(id);
      }),
      pass_product_ids: (data.pass_product_ids || []).map(function (id) {
        return String(id);
      }),
      excluded_collection_ids: data.excluded_collection_ids || [],
      rates: {
        with_code: withCodeRate / 100,
        first_order: firstRate / 100,
        repeat_order: renewRate / 100,
      },
      copy: copy,
      popup: mapWidgetToPdpPopup(data.widget, data, local.popup),
      cart_popup: data.cart_popup || local.cart_popup,
      cart: data.cart || local.cart,
    };
  }

  function mapWidgetToCartCopy(data, localConfig) {
    var widget = (data && data.widget) || {};
    if (!widget.title && !widget.main && !widget.sub && !widget.note) {
      return (localConfig && localConfig.cart) || null;
    }

    return {
      upsell_title: widget.title || "{price} Klaiyi Crown Pass",
      active_title: widget.title || "Your Crown Pass Is Active",
      upsell_banner_title: normalizeTemplatePlaceholders(
        widget.main || "Save Extra {amount} Today!"
      ),
      upsell_banner_subtitle:
        widget.sub ||
        "Extra 7% OFF Your First Order, 5% OFF All Later Orders",
      upsell_banner_footer:
        widget.note || "Valid In {days} Days | Unlimited Use",
      member_banner_title: "{days}-Day Membership",
      member_banner_subtitle: "Extra 5% OFF This Order",
      member_banner_footer: "Valid: {valid_from} - {valid_to}",
      _priceFromWidget: widget.title,
    };
  }

  function normalizeCartApiData(data, ctx) {
    var local = buildLocalConfig(ctx || {});
    var durationDays = data.duration_days != null ? data.duration_days : 90;
    var firstRate = data.first_rate != null ? Number(data.first_rate) : 7;
    var renewRate = data.renew_rate != null ? Number(data.renew_rate) : 5;
    var widgetCart = mapWidgetToCartCopy(data, local);

    var apiEnabled = !isApiEnabledExplicitlyOff(data.enabled);
    var masterOn = isCrownPassMasterSwitchOn(data);

    return {
      enabled: resolveCartApiEnabled(data, ctx),
      api_enabled: apiEnabled,
      feature_status: masterOn,
      api_status: masterOn,
      _checkoutCartApi: true,
      is_member: Boolean(data.is_member),
      user_status: data.is_member
        ? "member"
        : ctx && ctx.customerId
          ? "non_member"
          : "guest",
      membership_name: local.membership_name,
      membership_variant_id:
        data.pass_variant_id || local.membership_variant_id || null,
      membership_price_text:
        data.membership_price_text ||
        (widgetCart && widgetCart._priceFromWidget) ||
        local.membership_price_text,
      membership_price_cents: local.membership_price_cents,
      membership_valid_from: data.valid_from,
      membership_valid_to: data.valid_to,
      duration_days: durationDays,
      default_selected: data.default_selected === true,
      excluded_product_ids: (data.excluded_product_ids || []).map(function (id) {
        return String(id);
      }),
      pass_product_ids: (data.pass_product_ids || []).map(function (id) {
        return String(id);
      }),
      rate: data.rate,
      cart:
        data.cart ||
        widgetCart ||
        local.cart,
      cart_popup: data.cart_popup || local.cart_popup,
      popup: local.popup,
      copy: local.copy,
      rates: {
        with_code:
          data.rate != null ? Number(data.rate) / 100 : firstRate / 100,
        first_order: firstRate / 100,
        repeat_order: renewRate / 100,
      },
    };
  }

  function fetchDetailConfigFromApi(ctx) {
    var url =
      getApiBase() +
      DETAIL_API_PATH +
      "?product_id=" +
      encodeURIComponent(ctx.productId || "");

    var customerLegacyId = legacyCustomerId(ctx.customerId);
    if (customerLegacyId) {
      url += "&customer_id=" + encodeURIComponent(customerLegacyId);
    }

    return fetch(url, {
      headers: {
        Authorization: AUTH_TOKEN,
        "Content-Type": "application/json",
      },
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Crown Pass detail HTTP " + res.status);
        }
        return res.json();
      })
      .then(function (payload) {
        var data = parseApiPayload(payload);
        if (!data) {
          throw new Error("Crown Pass detail invalid response");
        }
        return normalizeDetailApiData(data, ctx);
      });
  }

  function fetchCartConfigFromApi(ctx) {
    var url = getApiBase() + CART_API_PATH;
    var customerLegacyId = legacyCustomerId(ctx && ctx.customerId);
    if (customerLegacyId) {
      url += "?customer_id=" + encodeURIComponent(customerLegacyId);
    }

    return fetch(url, {
      headers: {
        Authorization: AUTH_TOKEN,
        "Content-Type": "application/json",
      },
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Crown Pass cart HTTP " + res.status);
        }
        return res.json();
      })
      .then(function (payload) {
        var data = parseApiPayload(payload);
        if (!data) {
          throw new Error("Crown Pass cart invalid response");
        }
        return normalizeCartApiData(data, ctx || {});
      });
  }

  function fetchConfigFromApi(ctx) {
    ctx = ctx || {};
    if (ctx.productId) {
      return fetchDetailConfigFromApi(ctx);
    }
    return fetchCartConfigFromApi(ctx);
  }

  function loadConfig(ctx) {
    ctx = ctx || {};
    var cacheKey = getConfigCacheKey(ctx);

    if (configCacheByKey[cacheKey]) {
      return Promise.resolve(configCacheByKey[cacheKey]);
    }

    if (configPromiseByKey[cacheKey]) {
      return configPromiseByKey[cacheKey];
    }

    if (USE_LOCAL_CONFIG_ONLY) {
      configCacheByKey[cacheKey] = buildLocalConfig(ctx);
      return Promise.resolve(configCacheByKey[cacheKey]);
    }

    configPromiseByKey[cacheKey] = fetchConfigFromApi(ctx)
      .then(function (config) {
        configCacheByKey[cacheKey] = config;
        return config;
      })
      .catch(function (err) {
        console.warn("[CrownPass] API unavailable, using local config:", err);
        configCacheByKey[cacheKey] = buildLocalConfig(ctx);
        return configCacheByKey[cacheKey];
      })
      .finally(function () {
        configPromiseByKey[cacheKey] = null;
      });

    return configPromiseByKey[cacheKey];
  }

  function isProductIdExcluded(config, productId) {
    if (!config || productId == null || productId === "") return false;
    var excludedProducts = config.excluded_product_ids || [];
    return excludedProducts.some(function (id) {
      return String(id) === String(productId);
    });
  }

  function isCartLineExcludedProduct(line, config) {
    if (!line) return false;
    var productId =
      line.product_id != null ? line.product_id : line.productId;
    return isProductIdExcluded(config, productId);
  }

  function isCartGiftLine(line) {
    if (!line) return false;
    var props = line.properties || {};
    if (props.is_gift === "true" || props.is_gift === true) {
      return true;
    }
    if (
      props.newCustomerGlobalPoUpGiftProduct === "true" ||
      props.newCustomerGlobalPoUpGiftProduct === true
    ) {
      return true;
    }
    var title = String(line.product_title || line.title || "").toLowerCase();
    if (title.indexOf("free gift") !== -1) return true;
    return false;
  }

  /** 运费险 / 配送服务类行 — 不参与 Crown Pass 折扣基数（与赠品逻辑一致） */
  function isCartServiceLine(line) {
    if (!line) return false;
    var title = String(line.product_title || line.title || "").toLowerCase();
    if (title.indexOf("worry-free") !== -1) return true;
    if (title.indexOf("shipping protection") !== -1) return true;
    return false;
  }

  function isCartLineEligibleForCrownPassDiscount(line, config) {
    if (!line) return false;
    if (isMembershipLine(line, config)) return false;
    if (isCartGiftLine(line)) return false;
    if (isCartServiceLine(line)) return false;
    if (isCartLineExcludedProduct(line, config)) return false;
    return true;
  }

  function cartHasCrownPassEligibleMerchandise(cart, config) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(function (line) {
      return isCartLineEligibleForCrownPassDiscount(line, config);
    });
  }

  function cartHasNonGiftNonPassMerchandise(cart, config) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(function (line) {
      if (!line) return false;
      if (isCartGiftLine(line)) return false;
      if (isMembershipLine(line, config)) return false;
      return true;
    });
  }

  function isProductExcluded(config, ctx) {
    if (!config || !ctx) return true;

    if (isProductIdExcluded(config, ctx.productId)) {
      return true;
    }

    var excludedCollections = config.excluded_collection_ids || [];
    if (!excludedCollections.length || !ctx.collectionIds || !ctx.collectionIds.length) {
      return false;
    }

    return ctx.collectionIds.some(function (collectionId) {
      return excludedCollections.some(function (excludedId) {
        return String(excludedId) === String(collectionId);
      });
    });
  }

  function isMembershipCurrentlyValid(config) {
    if (!isPurchasedMember(config)) {
      return false;
    }
    var range = getMembershipValidityRange(config);
    var now = new Date();
    if (range.fromDate && now < range.fromDate) {
      return false;
    }
    if (range.toDate) {
      var end = new Date(range.toDate);
      end.setHours(23, 59, 59, 999);
      if (now > end) {
        return false;
      }
    }
    return true;
  }

  /** enabled 开关仅对未购会员 / 非有效期内会员（含未登录）生效 */
  function shouldRespectCrownPassEnabledGate(config) {
    return !isMembershipCurrentlyValid(config);
  }

  function isCrownPassFeatureEnabled(config, ctx) {
    ctx = ctx || {};
    if (!shouldRespectCrownPassEnabledGate(config)) {
      return true;
    }
    if (config && config.feature_status === false) {
      return false;
    }
    if (
      CROWN_PASS_GUEST_CART_IGNORE_ENABLED_FALSE &&
      config &&
      config._checkoutCartApi &&
      isCartGuestContext(ctx)
    ) {
      return true;
    }
    return !config || config.enabled !== false;
  }

  /** 总开关/分开关关闭时：未购有效会员须从购物车去掉会籍商品行 */
  function shouldRemoveMembershipFromCart(config, ctx) {
    if (!config) {
      return false;
    }
    if (!shouldRespectCrownPassEnabledGate(config)) {
      return false;
    }
    return !isCrownPassFeatureEnabled(config, ctx);
  }

  function shouldShowPdpModule(config, ctx) {
    if (!config) {
      return false;
    }
    if (isMembershipCurrentlyValid(config)) {
      if (config._pdpDetailApi) {
        return config.is_excluded !== true;
      }
      return !isProductExcluded(config, ctx);
    }
    if (!isCrownPassFeatureEnabled(config)) {
      return false;
    }
    if (config.discountable === false) {
      return false;
    }
    if (config._pdpDetailApi) {
      return config.is_excluded !== true;
    }
    return !isProductExcluded(config, ctx);
  }

  function shouldShowCartModule(config, cart, ctx) {
    ctx = ctx || {};
    if (!config) {
      return false;
    }
    if (!cart || !cart.items || !cart.items.length) {
      return false;
    }

    var hasEligible = cartHasCrownPassEligibleMerchandise(cart, config);
    var hasPassLine = cartHasMembershipLine(cart, config);

    if (!hasEligible && !hasPassLine) {
      return false;
    }

    if (isMembershipCurrentlyValid(config)) {
      return true;
    }

    if (!isCrownPassFeatureEnabled(config, ctx)) {
      return false;
    }

    return hasEligible || hasPassLine;
  }

  function invalidateCartConfigCache(ctx) {
    var key = getConfigCacheKey(ctx || {});
    delete configCacheByKey[key];
    configPromiseByKey[key] = null;
  }

  function explainShouldShowCartModule(config, cart, ctx) {
    ctx = ctx || {};
    var lineSummary = (cart && cart.items ? cart.items : []).map(function (line) {
      return {
        product_id: line.product_id,
        variant_id: line.variant_id,
        title: line.product_title || line.title,
        eligible: isCartLineEligibleForCrownPassDiscount(line, config),
        gift: isCartGiftLine(line),
        excluded: isCartLineExcludedProduct(line, config),
        membership: isMembershipLine(line, config),
      };
    });
    return {
      show: shouldShowCartModule(config, cart, ctx),
      guest: isCartGuestContext(ctx),
      featureEnabled: isCrownPassFeatureEnabled(config, ctx),
      membershipValid: isMembershipCurrentlyValid(config),
      hasEligibleMerchandise: cartHasCrownPassEligibleMerchandise(cart, config),
      hasNonGiftMerchandise: cartHasNonGiftNonPassMerchandise(cart, config),
      config: config
        ? {
            enabled: config.enabled,
            feature_status: config.feature_status,
            api_status: config.api_status,
            api_enabled: config.api_enabled,
            _checkoutCartApi: config._checkoutCartApi,
            excluded_product_ids: config.excluded_product_ids,
          }
        : null,
      lines: lineSummary,
    };
  }

  function parseMoneyTextToCents(text) {
    if (!text) return 0;
    var normalized = String(text)
      .replace(/[^\d.,]/g, "")
      .replace(/,/g, "");
    var value = parseFloat(normalized);
    if (isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  function formatSavingAmount(cents) {
    cents = Math.floor(Math.max(Number(cents) || 0, 0));

    if (
      global.KlaiyiUtils &&
      typeof global.KlaiyiUtils.setPriceEl === "function" &&
      global.jQuery
    ) {
      var $temp = global.jQuery('<span class="money"></span>');
      global.KlaiyiUtils.setPriceEl($temp, cents);
      var formatted = $temp.text().trim();
      if (formatted) return formatted;
    }

    if (global.Shopify && typeof global.Shopify.formatMoney === "function") {
      return global.Shopify.formatMoney(
        cents,
        (global.theme && global.theme.moneyFormat) ||
          global.__moneyFormat ||
          "${{amount}}"
      );
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function applyCopyTemplate(template, replacements) {
    var text = String(template || "");
    Object.keys(replacements || {}).forEach(function (key) {
      text = text.replace(new RegExp("\\{" + key + "\\}", "g"), replacements[key]);
    });
    return text;
  }

  function getDiscountRate(config, ctx, useCodeRate) {
    if (
      config &&
      config._pdpDetailApi &&
      config.rate != null &&
      !isNaN(Number(config.rate))
    ) {
      return Number(config.rate) / 100;
    }

    if (
      config &&
      config._checkoutCartApi &&
      config.rate != null &&
      !isNaN(Number(config.rate))
    ) {
      return Number(config.rate) / 100;
    }

    var rates = (config && config.rates) || {};
    var withCodeRate = rates.with_code != null ? rates.with_code : 0.07;
    var firstOrderRate = rates.first_order != null ? rates.first_order : 0.07;
    var repeatOrderRate = rates.repeat_order != null ? rates.repeat_order : 0.05;

    if (useCodeRate) {
      return withCodeRate;
    }

    var ordersCount =
      (ctx && ctx.ordersCount) ||
      (global.__pdpNewCustomerEligibility &&
        global.__pdpNewCustomerEligibility.ordersCount) ||
      0;

    return ordersCount > 0 ? repeatOrderRate : firstOrderRate;
  }

  function calculateSavingCents(baseCents, config, ctx, useCodeRate) {
    var rate = getDiscountRate(config, ctx, useCodeRate);
    return Math.floor(Math.max(Number(baseCents) || 0, 0) * rate);
  }

  function isPurchasedMember(config) {
    return !!(
      config &&
      (config.user_status === "member" || config.is_member === true)
    );
  }

  function isActiveMember(config) {
    if (isPurchasedMember(config)) {
      return true;
    }
    return getMockMembershipStatus() === "active";
  }

  function getDefaultSelectedDismissed() {
    try {
      return (
        global.sessionStorage.getItem(DEFAULT_SELECTED_DISMISSED_KEY) ===
          "true" ||
        global.localStorage.getItem(DEFAULT_SELECTED_DISMISSED_KEY) === "true"
      );
    } catch (err) {
      return false;
    }
  }

  function setDefaultSelectedDismissed(dismissed) {
    try {
      if (dismissed) {
        global.sessionStorage.setItem(DEFAULT_SELECTED_DISMISSED_KEY, "true");
        global.localStorage.setItem(DEFAULT_SELECTED_DISMISSED_KEY, "true");
      } else {
        global.sessionStorage.removeItem(DEFAULT_SELECTED_DISMISSED_KEY);
        global.localStorage.removeItem(DEFAULT_SELECTED_DISMISSED_KEY);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function isPdpPassSelected(config) {
    if (isPurchasedMember(config)) {
      return false;
    }
    if (getDefaultSelectedDismissed()) {
      return false;
    }
    if (getPdpCartSelected()) {
      return true;
    }
    if (getMockMembershipStatus() === "active") {
      return true;
    }
    if (config && config.default_selected === true && !getDefaultSelectedDismissed()) {
      return true;
    }
    return false;
  }

  function applyPdpDefaultSelected(config, ctx) {
    if (!shouldAutoSelectCrownPassFromPdp(config)) {
      return Promise.resolve();
    }
    return applyDefaultSelectedFromConfig(config, ctx);
  }

  function cartHasMembershipLine(cart, config) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (line) {
      return isMembershipLine(line, config);
    });
  }

  function getMembershipPriceCents(config, cart) {
    if (cartHasMembershipLine(cart, config)) {
      return 0;
    }
    if (config && config.membership_price_cents != null) {
      return Math.max(Number(config.membership_price_cents) || 0, 0);
    }
    return parseMoneyTextToCents(
      (config && config.membership_price_text) || "$19.9"
    );
  }

  function resolvePopupState(config) {
    if (isPurchasedMember(config)) {
      return "member";
    }
    if (isPdpPassSelected(config)) {
      return "active";
    }
    return "purchase";
  }

  function lineHasMembershipProperty(line) {
    if (!line || !line.properties) return false;
    if (line.properties._crown_pass_membership === "true") {
      return true;
    }
    if (Array.isArray(line.properties)) {
      return line.properties.some(function (prop) {
        return (
          prop &&
          prop.name === "_crown_pass_membership" &&
          String(prop.value) === "true"
        );
      });
    }
    return false;
  }

  function getConfiguredMembershipVariantId() {
    var ctx =
      global.__CROWN_PASS_CART__ && global.__CROWN_PASS_CART__.membershipVariantId;
    return ctx != null && ctx !== "" ? String(ctx) : "";
  }

  function isMembershipLine(line, config) {
    if (!line) return false;
    if (lineHasMembershipProperty(line)) {
      return true;
    }
    if (line.selling_plan_allocation) {
      return false;
    }
    var variantId = line.variant_id != null ? String(line.variant_id) : "";
    var configuredVariantId = "";
    if (config && config.membership_variant_id != null && config.membership_variant_id !== "") {
      configuredVariantId = String(config.membership_variant_id);
    }
    if (!configuredVariantId) {
      configuredVariantId = getConfiguredMembershipVariantId();
    }
    if (configuredVariantId && variantId === configuredVariantId) {
      return true;
    }

    var productId =
      line.product_id != null
        ? String(line.product_id)
        : "";
    var passProductIds = (config && config.pass_product_ids) || [];
    if (
      productId &&
      passProductIds.some(function (id) {
        return String(id) === productId;
      })
    ) {
      if (!configuredVariantId || variantId === configuredVariantId) {
        return true;
      }
    }

    return false;
  }

  function getCartEligibleSubtotalCents(cart, config) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    var total = 0;
    cart.items.forEach(function (line) {
      if (!isCartLineEligibleForCrownPassDiscount(line, config)) return;
      total += Number(line.final_line_price) || 0;
    });
    return total;
  }

  function cartHasDiscount(cart, config) {
    if (!cart) return false;
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      return true;
    }
    if (!cart.items) return false;
    return cart.items.some(function (line) {
      if (isMembershipLine(line, config)) return false;
      if (isCartLineExcludedProduct(line, config)) return false;
      return (
        (line.line_level_discount_allocations &&
          line.line_level_discount_allocations.length > 0) ||
        Number(line.original_line_price) > Number(line.final_line_price)
      );
    });
  }

  function isCrownPassDiscountTitle(title) {
    return String(title || "")
      .toLowerCase()
      .indexOf("crown pass") !== -1;
  }

  function isCrownPassDiscountAllocation(allocation) {
    if (!allocation) return false;
    var app = allocation.discount_application || {};
    return isCrownPassDiscountTitle(app.title || app.name);
  }

  function isCrownPassDiscountApplication(app) {
    if (!app) return false;
    return isCrownPassDiscountTitle(app.title || app.name);
  }

  function sumCrownPassCartLevelDiscountCents(cart) {
    if (!cart || !cart.cart_level_discount_applications) return 0;
    var total = 0;
    cart.cart_level_discount_applications.forEach(function (app) {
      if (!isCrownPassDiscountApplication(app)) return;
      total += Number(app.total_allocated_amount) || 0;
    });
    return total;
  }

  function hasShopifyAppliedCrownPassDiscount(cart, config) {
    return (
      sumCrownPassDiscountAllocationsCents(cart, config) > 0 ||
      sumCrownPassCartLevelDiscountCents(cart) > 0
    );
  }

  /** 与行内 CartItem__Discount 一致：汇总 Shopify 已生效的 Crown Pass 行级折扣 */
  function sumCrownPassDiscountAllocationsCents(cart, config) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function (line) {
      if (!isCartLineEligibleForCrownPassDiscount(line, config)) return;
      (line.line_level_discount_allocations || []).forEach(function (allocation) {
        if (isCrownPassDiscountAllocation(allocation)) {
          total += Number(allocation.amount) || 0;
        }
      });
    });
    return total;
  }

  function getCartEligibleSubtotalForSavingEstimateCents(cart, config) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function (line) {
      if (!isCartLineEligibleForCrownPassDiscount(line, config)) return;
      var finalCents = Number(line.final_line_price) || 0;
      var crownPassCents = 0;
      (line.line_level_discount_allocations || []).forEach(function (allocation) {
        if (isCrownPassDiscountAllocation(allocation)) {
          crownPassCents += Number(allocation.amount) || 0;
        }
      });
      if (crownPassCents > 0) {
        total += finalCents + crownPassCents;
      } else {
        total += finalCents;
      }
    });
    return total;
  }

  function calculateCartSavingCents(cart, config, ctx) {
    var cartLevelCents = sumCrownPassCartLevelDiscountCents(cart);
    if (cartLevelCents > 0) {
      return cartLevelCents;
    }

    var appliedCents = sumCrownPassDiscountAllocationsCents(cart, config);
    if (appliedCents > 0) {
      return appliedCents;
    }

    var useCodeRate = cartHasDiscount(cart, config);
    var eligibleSubtotal = getCartEligibleSubtotalForSavingEstimateCents(
      cart,
      config
    );
    if (eligibleSubtotal <= 0) {
      return 0;
    }
    var rate = getDiscountRate(config, ctx, useCodeRate);
    return Math.round(eligibleSubtotal * rate);
  }

  function shouldApplyCartSaving(config, cart) {
    var uiState = resolveCartUiState(config, cart);
    return uiState === "member" || uiState === "selected";
  }

  function calculateCartDisplayTotalCents(cart, config, ctx) {
    var baseTotal = Number((cart && cart.total_price) || 0);
    var uiState = resolveCartUiState(config, cart);

    if (uiState === "unselected") {
      return baseTotal;
    }

    var membershipFeeCents =
      uiState === "selected" ? getMembershipPriceCents(config, cart) : 0;

    if (
      cartHasMembershipLine(cart, config) ||
      hasShopifyAppliedCrownPassDiscount(cart, config)
    ) {
      return Math.max(baseTotal + membershipFeeCents, 0);
    }

    var savingCents = calculateCartSavingCents(cart, config, ctx);
    return Math.max(baseTotal + membershipFeeCents - savingCents, 0);
  }

  function resolveCartUiState(config, cart) {
    if (!cart || !cart.items) {
      return isPurchasedMember(config) ? "member" : "unselected";
    }
    var hasMembershipLine = cart.items.some(function (line) {
      return isMembershipLine(line, config);
    });
    if (getDefaultSelectedDismissed() && !hasMembershipLine) {
      if (isPurchasedMember(config)) {
        return "member";
      }
      return "unselected";
    }
    var selected = hasMembershipLine;
    if (!selected && cart.attributes && cart.attributes.crown_pass_selected === "true") {
      selected = true;
    }
    if (!selected && isDefaultSelectedConfig(config)) {
      selected = true;
    }
    if (selected) {
      return "selected";
    }
    if (isPurchasedMember(config)) {
      return "member";
    }
    return "unselected";
  }

  function getCartCopyReplacements(config, extra) {
    var range = getMembershipValidityRange(config);
    var days =
      config && config.duration_days != null ? String(config.duration_days) : "90";
    var base = {
      days: days,
      price: (config && config.membership_price_text) || "$19.9",
      valid_from: range.fromDate ? formatDateMonthDayYear(range.fromDate) : "",
      valid_to: range.toDate ? formatDateMonthDayYear(range.toDate) : "",
    };
    if (!extra) {
      return base;
    }
    return Object.assign(base, extra);
  }

  function parseDateValue(value) {
    if (!value) return null;
    var date = new Date(value);
    if (isNaN(date.getTime())) return null;
    return date;
  }

  function formatDateMonthDayYear(date) {
    if (!date) return "";
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  function formatDatePopupUpper(date) {
    if (!date) return "";
    var months = [
      "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
    ];
    return months[date.getMonth()] + "." + date.getDate() + "." + date.getFullYear();
  }

  function getMembershipValidityRange(config) {
    var fromDate = parseDateValue(config && config.membership_valid_from);
    var toDate = parseDateValue(config && config.membership_valid_to);
    return { fromDate: fromDate, toDate: toDate };
  }

  function getMembershipValidityText(config, popupConfig) {
    var range = getMembershipValidityRange(config);
    if (range.fromDate && range.toDate) {
      return (
        "VALID: " +
        formatDatePopupUpper(range.fromDate) +
        " - " +
        formatDatePopupUpper(range.toDate)
      );
    }
    return (popupConfig && popupConfig.validity_text) || "";
  }

  function getCartPopupFooter(config, isMember) {
    var cartPopup = (config && config.cart_popup) || {};
    if (!isMember) {
      return cartPopup.non_member_footer || "90-Day Membership";
    }

    var validity = getMembershipValidityText(config, cartPopup);
    if (validity) return validity;

    return cartPopup.member_footer || "VALID: SEP.1.2026 - DEC.1.2026";
  }

  function getCartMemberBannerFooter(config) {
    var range = getMembershipValidityRange(config);
    if (range.fromDate && range.toDate) {
      return (
        "Valid: " +
        formatDateMonthDayYear(range.fromDate) +
        " - " +
        formatDateMonthDayYear(range.toDate)
      );
    }
    return ((config && config.cart) || {}).member_banner_footer ||
      "Valid: Sep 1, 2026 - Dec 1, 2026";
  }

  global.CrownPassCore = {
    CROWN_PASS_GUEST_CART_IGNORE_ENABLED_FALSE:
      CROWN_PASS_GUEST_CART_IGNORE_ENABLED_FALSE,
    USE_LOCAL_CONFIG_ONLY: USE_LOCAL_CONFIG_ONLY,
    MOCK_STATUS_KEY: MOCK_STATUS_KEY,
    PDP_CART_SELECTED_KEY: PDP_CART_SELECTED_KEY,
    RETENTION_POPUP_SHOWN_KEY: RETENTION_POPUP_SHOWN_KEY,
    loadConfig: loadConfig,
    invalidateCartConfigCache: invalidateCartConfigCache,
    explainShouldShowCartModule: explainShouldShowCartModule,
    buildLocalConfig: buildLocalConfig,
    shouldShowPdpModule: shouldShowPdpModule,
    shouldShowCartModule: shouldShowCartModule,
    isProductExcluded: isProductExcluded,
    getMembershipValidityText: getMembershipValidityText,
    getMockMembershipStatus: getMockMembershipStatus,
    setMockMembershipStatus: setMockMembershipStatus,
    getPdpCartSelected: getPdpCartSelected,
    setPdpCartSelected: setPdpCartSelected,
    shouldAutoSelectCrownPassFromPdp: shouldAutoSelectCrownPassFromPdp,
    isDefaultSelectedConfig: isDefaultSelectedConfig,
    applyDefaultSelectedFromConfig: applyDefaultSelectedFromConfig,
    persistPdpSelectionToShopifyCart: persistPdpSelectionToShopifyCart,
    clearPdpSelectionFromShopifyCart: clearPdpSelectionFromShopifyCart,
    deselectCrownPassOnShopifyCart: deselectCrownPassOnShopifyCart,
    preparePdpCartAddPayloadWithMembership: preparePdpCartAddPayloadWithMembership,
    waitForMembershipLineInCart: waitForMembershipLineInCart,
    addMembershipVariantToCart: addMembershipVariantToCart,
    ensureCrownPassMembershipAfterPdpAdd: ensureCrownPassMembershipAfterPdpAdd,
    getRetentionPopupShown: getRetentionPopupShown,
    setRetentionPopupShown: setRetentionPopupShown,
    getRetentionRatePercents: getRetentionRatePercents,
    getDefaultSelectedDismissed: getDefaultSelectedDismissed,
    setDefaultSelectedDismissed: setDefaultSelectedDismissed,
    isPdpPassSelected: isPdpPassSelected,
    applyPdpDefaultSelected: applyPdpDefaultSelected,
    parseMoneyTextToCents: parseMoneyTextToCents,
    formatSavingAmount: formatSavingAmount,
    applyCopyTemplate: applyCopyTemplate,
    getDiscountRate: getDiscountRate,
    calculateSavingCents: calculateSavingCents,
    calculateCartSavingCents: calculateCartSavingCents,
    shouldApplyCartSaving: shouldApplyCartSaving,
    calculateCartDisplayTotalCents: calculateCartDisplayTotalCents,
    isPurchasedMember: isPurchasedMember,
    isMembershipCurrentlyValid: isMembershipCurrentlyValid,
    isCrownPassFeatureEnabled: isCrownPassFeatureEnabled,
    shouldRemoveMembershipFromCart: shouldRemoveMembershipFromCart,
    isActiveMember: isActiveMember,
    getMembershipPriceCents: getMembershipPriceCents,
    cartHasMembershipLine: cartHasMembershipLine,
    resolvePopupState: resolvePopupState,
    resolveCartUiState: resolveCartUiState,
    getCartCopyReplacements: getCartCopyReplacements,
    isMembershipLine: isMembershipLine,
    isCrownPassDiscountTitle: isCrownPassDiscountTitle,
    cartHasDiscount: cartHasDiscount,
    getCartEligibleSubtotalCents: getCartEligibleSubtotalCents,
    getCartPopupFooter: getCartPopupFooter,
    getCartMemberBannerFooter: getCartMemberBannerFooter,
  };
})(window);
